/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AlertsLog {
    angular.module('meevo.plugins.alertsLog', []);
}